<template>
    <section>
        <div class="container">
            <IconClose class="header__search-close close" @click.stop.prevent="closeSearchModule"></IconClose>

            <div class="header__search-header">
                <h4 class="header__search-title">Szukaj w serwisie</h4>
                <p class="header__search-subtitle">Zacznij pisać...</p>
            </div>

            <div class="header__search-body">
                <input type="text" class="header__search-input" autofocus v-model="query" @keyup.enter="goToSearch" ref="searchform" aria-label="Szukaj">
            </div>

            <transition name="fade">
                <div class="header__search-btns" v-if="isButtons">
                    <button class="header__search-search" @click.stop.prevent="goToSearch"><span>Szukaj</span></button>
                    <button class="header__search-cancel" @click.stop.prevent="resetQuery">Anuluj</button>
                </div>
            </transition>
        </div>
    </section>
</template>

<script>
import IconClose from "./icons/IconClose.vue";

export default {
    name: "HeaderSearch",
    components: {
        IconClose,
    },
    data() {
        return {
            query: '',
            isButtons: false,
        };
    },
    watch: {
        query() {
            if (this.query.length > 2) {
                this.isButtons = true;
            } else {
                this.isButtons = false;
            }
        }
    },
    methods: {
        resetQuery() {
            this.query = '';
        },
        closeSearchModule() {
            this.$store.dispatch("changeSearchState");
        },
        goToSearch() {
            this.closeSearchModule();
            
            if(this.query) {
                this.$router.push({
                    name: "Search",
                    path: "/wyszukiwarka",
                    query: { query: `${this.query}` },
                });
            }
        },
    },
};
</script>
